import { app } from '../../../../../app';
import { Controller } from './hard-token-settings.controller';

app.component('editHardTokenSettings', {
   bindings: {
        companyId: '<',
        token: '=',
    },
    controller: Controller,
    templateUrl: require('./hard-token-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.component.js